import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = {
  ref: "messagesRef",
  class: "messages"
}
const _hoisted_3 = { class: "avatar-wrapper" }
const _hoisted_4 = { class: "message_text" }
const _hoisted_5 = { class: "message_text_name" }
const _hoisted_6 = { class: "message_text_message" }
const _hoisted_7 = {
  key: 0,
  class: "fas fa-check-circle"
}
const _hoisted_8 = { class: "send-message" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-reply" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: (message, index),
          class: _normalizeClass(["message", {
          'my-message': _ctx.isMessageMyMessage(message),
          'correct-guess': message.message.isCorrectGuess,
        }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.isMessageMyMessage(message))
              ? (_openBlock(), _createBlock(_component_avatar, {
                  key: 0,
                  size: 25,
                  username: message.sender.name
                }, null, 8, ["username"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(message.sender.name), 1),
            _createElementVNode("p", _hoisted_6, [
              (message.message.isCorrectGuess)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(message.message.message), 1)
            ])
          ])
        ], 2))
      }), 128))
    ], 512),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Type something...",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMessage()), ["prevent"]), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.message]
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendMessage()))
      }, _hoisted_10)
    ])
  ]))
}